import {addQueryArgs} from "@wordpress/url";

const interestRateCompareNode = document.querySelector('.bepos-interest-rate-compare');
let data = {};
// let unsecuredLoanPage = 1;
// let mortgageLoanPage = 1;

document.addEventListener('DOMContentLoaded', (event) => {
    if (!interestRateCompareNode) {
        return;
    }

    toggleField();
    getUnsecuredLoanBepos(true);
    getMortgageLoanBepos(true);
    filterOrSortBepos();
    // pagination();
});

const toggleField = () => {
    const items = interestRateCompareNode.querySelectorAll('.form-field');
    [...items].map(item => {
        const toggle = item.querySelector('.toggle');

        toggle.addEventListener('click', function (event) {
            if (item.classList.contains('active')) {
                item.classList.remove('active')
            } else {
                item.classList.add('active')
            }
        });
    });
    document.addEventListener('click', function (event) {
        const target = event.target;

        const formField = target.closest('.form-field');
        if (!formField) {
            [...items].map(item => {
                const toggle = item.querySelector('.toggle');

                item.classList.remove('active');
            });
        }
    });
}

const filterOrSortBepos = () => {
    //Loan Purpose
    const loanPurposeList = document.querySelectorAll('.form-field[data-type="loan_purpose"] ul.options li');

    [...loanPurposeList].map((el) => {
        el.addEventListener('click', function () {
            [...loanPurposeList].map((el2) => {
                el2.classList.remove('active');
            });

            el.classList.add('active');
            const toggle = document.querySelector('.form-field[data-type="loan_purpose"] .toggle');
            toggle.innerHTML = el.innerHTML;
            data = {...data, loan_purpose: el.getAttribute('data-value')}
            getUnsecuredLoanBepos();
            getMortgageLoanBepos();
        });
    })

    //Duration
    const durationList = document.querySelectorAll('.form-field[data-type="duration"] ul.options li');

    [...durationList].map((el) => {
        el.addEventListener('click', function () {
            [...durationList].map((el2) => {
                el2.classList.remove('active');
            });

            el.classList.add('active');
            const toggle = document.querySelector('.form-field[data-type="duration"] .toggle');
            toggle.innerHTML = el.innerHTML;
            data = {...data, duration: el.getAttribute('data-value')}
            getUnsecuredLoanBepos();
            getMortgageLoanBepos();
        });
    })

    //loan_type
    const loanTypes = document.querySelectorAll('.form-field[data-type="loan_type"] input[name="loan_type"]');

    [...loanTypes].map((el) => {
        el.addEventListener('change', function (event) {
            let loanTypeValue = [];
            [...loanTypes].map((el2) => {
                if (el2.checked) {
                    loanTypeValue = [...loanTypeValue, el2.value];
                }
            });

            data = {...data, loan_type: loanTypeValue};
            getUnsecuredLoanBepos();
            getMortgageLoanBepos();
        });
    });

    //banks
    const banks = document.querySelectorAll('.form-field[data-type="bank"] input[name="bank"]');

    [...banks].map((el) => {
        el.addEventListener('change', function (event) {
            let bankValue = [];
            [...banks].map((el2) => {
                if (el2.checked) {
                    bankValue = [...bankValue, el2.value];
                }
            });

            data = {...data, bank: bankValue}
            getUnsecuredLoanBepos();
            getMortgageLoanBepos();
        });
    });

    //sort
    const sort = document.querySelectorAll('.form-field[data-type="loan_sort"] ul.options li');

    [...sort].map((el) => {
        el.addEventListener('click', function () {
            [...sort].map((el2) => {
                el2.classList.remove('active');
            });

            el.classList.add('active');
            const toggle = document.querySelector('.form-field[data-type="loan_sort"] .toggle');
            toggle.innerHTML = el.innerHTML;

            data = {...data, loan_sort: el.getAttribute('data-value')}
            getUnsecuredLoanBepos();
            getMortgageLoanBepos();
        });
    })
}

const getUnsecuredLoanBepos = (isFirstLoad = false) => {
    const content = document.querySelector('.unsecured_loan_content .res-content-body');

    if (!content) {
        return;
    }

    const tbody = content.querySelector('table tbody');

    let queryData = {...data};

    if (Array.isArray(queryData.loan_type) && queryData.loan_type.length === 1 && queryData.loan_type[0] === 'mortgage_loan') {
        tbody.innerHTML = '';

        return;
    } else {
        queryData = {...queryData, loan_type: ['unsecured_loan']}
    }

    content.classList.add('loading');

    wp.apiFetch({
        path: addQueryArgs('/bepos/v1/bepos-products', queryData), method: 'GET',

    }).then((res) => {
        if (res.status === 'success') {
            tbody.innerHTML = res.data.content;
        } else {
            console.log(res.message);
        }
    }).catch((err) => {
        console.log(err);
    }).finally(() => {
        content.classList.remove('loading');
    });
}

const getMortgageLoanBepos = (isFirstLoad = false) => {
    const content = document.querySelector('.mortgage_loan_content .res-content-body');

    if (!content) {
        return;
    }

    let queryData = {...data};

    const tbody = content.querySelector('table tbody');
    if (Array.isArray(queryData.loan_type) && queryData.loan_type.length === 1 && queryData.loan_type[0] === 'unsecured_loan') {
        tbody.innerHTML = '';

        return;
    } else {
        queryData = {...queryData, loan_type: ['mortgage_loan']}
    }

    content.style.opacity = 0.4;
    wp.apiFetch({
        path: addQueryArgs('/bepos/v1/bepos-products', queryData), method: 'GET',

    }).then((res) => {
        if (res.status === 'success') {
            tbody.innerHTML = res.data.content;
        } else {
            console.log(res.message);
        }
    }).catch((err) => {
        console.log(err);
    }).finally(() => {
        content.style.opacity = 1;
    });
}

// const pagination = () => {
//
// }
